import { render } from "./NavbarToggleButton.vue?vue&type=template&id=426446e3"
import script from "./NavbarToggleButton.vue?vue&type=script&lang=js"
export * from "./NavbarToggleButton.vue?vue&type=script&lang=js"
script.render = render

export default script